var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdResource } from "../../../../constants/IdResource";
import { IdStyles } from "../../../../less/IdStyles";
import { selectActiveBuildingCostBuff } from "../../../../selectors/selectBuffsInfo";
import { selectActiveDiscountEventForBuildingId } from "../../../../selectors/selectDiscountEvent";
import { selectBuildingConstructionTime, selectBuildingUpgradeInfo, selectSelectedBuildingInfo, } from "../../../../selectors/selectExistingBuildingInfo";
import { IdLoca } from "../../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../../utils/i18n/ReplacementLoca";
import { DialogWrapper } from "../../../dialog/DialogWrapper";
import { componentWithProps } from "../../../generic/componentWithProps";
import { ResourceBar } from "../../../generic/resource-bar/ResourceBar";
import { TextLoca } from "../../../generic/text/TextLoca";
import { actionModalClose, actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionBuildingsRequestUpgrade } from "../actionBuildings";
import { BuildingUpgrade } from "./BuildingUpgrade";
var MenuBuildingUpgradeDOM = /** @class */ (function (_super) {
    __extends(MenuBuildingUpgradeDOM, _super);
    function MenuBuildingUpgradeDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getLevelLockStandard = function (next, type) {
            var playerLevel = _this.props.playerLevel;
            if (next[type] && playerLevel < next[type].requPlayerLevel) {
                var locaReplacements = new Map([
                    [ReplacementLoca.zero_0, next[type].requPlayerLevel.toString()],
                ]);
                return {
                    difference: next[type].requPlayerLevel - playerLevel,
                    message: (React.createElement(TextLoca, { id: IdLoca.floatingText_levelCap, replacements: locaReplacements })),
                    requPlayerLevel: next[type].requPlayerLevel,
                };
            }
            return undefined;
        };
        return _this;
    }
    MenuBuildingUpgradeDOM.prototype.render = function () {
        var _a = this.props, building = _a.building, buildingUpgradeInfo = _a.buildingUpgradeInfo, onClose = _a.onClose, onUpgradeGold = _a.onUpgradeGold, onUpgradeResources = _a.onUpgradeResources, onInfoButton = _a.onInfoButton, getConstructionTime = _a.getConstructionTime, discountEvent = _a.discountEvent, discountPremiumBuff = _a.discountPremiumBuff;
        if (buildingUpgradeInfo == undefined ||
            building == undefined ||
            buildingUpgradeInfo.nextStage == undefined) {
            return React.createElement(React.Fragment, null);
        }
        var current = buildingUpgradeInfo.currentStage;
        var next = buildingUpgradeInfo.nextStage;
        var constructionTime = getConstructionTime(building.balancing.id, next.level);
        var getLevelLockStandard = this.getLevelLockStandard(next, "standard");
        var footerResources = [IdResource.Money, IdResource.Gold];
        var footerComponent = componentWithProps({
            ComponentType: ResourceBar,
            className: "modal-footer--upgrade-building",
            resources: footerResources,
        });
        return (React.createElement(DialogWrapper, { className: IdStyles.ModalBackgroundBuildingUpgrade, titleLocaId: IdLoca.upgrade, onClose: onClose, footerRenderer: footerComponent },
            React.createElement(BuildingUpgrade, { currentStage: current, nextStage: next, building: building, constructionTime: constructionTime, onInfoButton: onInfoButton, levelLockStandard: getLevelLockStandard, onUpgradeGold: onUpgradeGold, onUpgradeResources: onUpgradeResources, discountEvent: discountEvent, discountPremiumBuff: discountPremiumBuff })));
    };
    return MenuBuildingUpgradeDOM;
}(React.Component));
var mapState = function (state) {
    var building = selectSelectedBuildingInfo(state);
    var discountEvent;
    var discountPremiumBuff;
    if (building) {
        var bId = building.balancing.id;
        discountEvent = selectActiveDiscountEventForBuildingId(state, bId);
        discountPremiumBuff = selectActiveBuildingCostBuff(state, bId, IdResource.Gold);
    }
    var playerLevel = state.playerInfo.level || 1;
    var buildingUpgradeInfo = building !== undefined ? selectBuildingUpgradeInfo(building) : undefined;
    return {
        building: building,
        buildingUpgradeInfo: buildingUpgradeInfo,
        discountEvent: discountEvent,
        discountPremiumBuff: discountPremiumBuff,
        getConstructionTime: function (buildingId, level) {
            return selectBuildingConstructionTime(state, buildingId, level);
        },
        playerLevel: playerLevel,
    };
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onClose: function () { return actionModalClose(IdModal.BuildingUpgrade); },
        onInfoButton: function () { return actionModalOpen(IdModal.BuildingInfo); },
        onUpgradeGold: function (building) {
            return actionBuildingsRequestUpgrade(building, true);
        },
        onUpgradeResources: function (building) {
            return actionBuildingsRequestUpgrade(building, false);
        },
    }, dispatch);
};
export var MenuBuildingUpgrade = connect(mapState, mapDispatch)(MenuBuildingUpgradeDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/upgrade/MenuBuildingUpgrade.tsx
// module id = 2858
// module chunks = 3